module.exports = __webpack_public_path__ + "static/img/r-1.2b3b903.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blog/renovation/r-1.jpg
// module id = mFxO
// module chunks = 0